import jwtAxios from "@richbeauty/services/auth/jwt-auth/jwt-api";
import { URL_API } from "@richbeauty/services/endpoint";
import useSWRMutation from "swr/mutation";

const updateTask = async ({ id, ...data }) => {
  return jwtAxios.patch(`/${URL_API.CMS_TASKS.PATCH_TASK}/${id}`, data);
};

const useUpdateTask = () => {
  const fetcher = (url, { arg }) => updateTask(arg);
  return useSWRMutation(`/${URL_API.CMS_TASKS.PATCH_TASK}`, fetcher);
};

export default useUpdateTask;
